import { Injectable } from '@angular/core';
import {
    HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoggingService } from '@Services/logging.service';

const HTTP1_THROTTLE_MS = 30_000;
const HTTP2_THROTTLE_MS = 300_000;
const LOOKUP_DELAY_MS = 100;
const RETRY_DELAY_MS = 500;

@Injectable()
export class HttpProtocolLoggingInterceptor implements HttpInterceptor {

    private lastLoggedHttp1 = 0;
    private lastLoggedHttp2 = 0;

    constructor(private logger: LoggingService) { }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap(event => {
                if (event instanceof HttpResponse) {
                    const url = event.url || req.urlWithParams;
                    setTimeout(() => this.logProtocol(url, true), LOOKUP_DELAY_MS);
                }
            })
        );
    }

    private logProtocol(url: string, allowRetry: boolean): void {
        const protocol = this.logger.getProtocol(url);
        if (!protocol) {
            if (allowRetry) {
                setTimeout(() => this.logProtocol(url, false), RETRY_DELAY_MS);
            }
            return;
        }

        this.logger.lastHttpProtocol = protocol;

        const now = Date.now();
        const isHttp1 = protocol === 'http/1.1'
            || protocol === 'http/1.0';

        if (isHttp1) {
            if (now - this.lastLoggedHttp1 < HTTP1_THROTTLE_MS) {
                return;
            }
            this.lastLoggedHttp1 = now;
        } else {
            if (now - this.lastLoggedHttp2 < HTTP2_THROTTLE_MS) {
                return;
            }
            this.lastLoggedHttp2 = now;
        }

        this.logger.logEvent('HttpProtocolUsage', {
            protocol,
            url
        });
    }
}
